import $ from '../vendor/jquery';

skrollr.init({
      smoothScrolling: false,
      easing: 'swing',
      forceHeight: false,
      mobileCheck: function() {}
    });

// Image Galleries
$('.js-gallery').each(function(){
  var $slides = $(this).find('.js-gallery__slides');
  var $nav_prev = $(this).find('.js-gallery__prev');
  var $nav_next = $(this).find('.js-gallery__next');
  var $thumbs = $(this).find('.js-gallery__thumbs');
  var $thumbNavs = $thumbs.find('a');
  var $thumbs_nav_prev = $(this).find('.js-gallery__thumbs-prev');
  var $thumbs_nav_next = $(this).find('.js-gallery__thumbs-next');

  $thumbs.find('li:first-child a').addClass('is-current');

  $slides.owlCarousel({
    loop: false,
    margin: 0,
    nav: false,
    dots: false,
    callbacks: true,
    items: 1
  });

  $nav_prev.click(function(e) {
    $slides.trigger('prev.owl.carousel');
    e.preventDefault();
  });

  $nav_next.click(function(e) {
    $slides.trigger('next.owl.carousel');
    e.preventDefault();
  });

  $thumbs.owlCarousel({
    loop: false,
    nav: false,
    dots: false,
    callbacks: true,
    items: 5,
    responsive: {
      0: {
        margin: 0
      },
      768: {
        margin: 15
      }
    }
  });

  $thumbs_nav_prev.click(function(e) {
    $thumbs.trigger('prev.owl.carousel');
    e.preventDefault();
  });

  $thumbs_nav_next.click(function(e) {
    $thumbs.trigger('next.owl.carousel');
    e.preventDefault();
  });

  $thumbNavs.click(function(e) {
    var $target = $(this);
    var $parent = $target.closest('.js-gallery__thumbs');
    var $allThumbs = $parent.find('a');
    var selectedSlide = $target.closest('.owl-item').index();
    $slides.trigger('to.owl.carousel', [selectedSlide, 200, true]);
    $allThumbs.removeClass('is-current');
    $target.addClass('is-current');
    e.preventDefault();
  });
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/gallery.js